import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboardSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard-sparkle, movie, film, ai"><path d="M20.25 12.5V3.75H3.75V20.25H12.5" stroke="currentColor" strokeWidth="1.5"/><path d="M4 8.75H20" stroke="currentColor" strokeWidth="1.5"/><path d="M8.25 8.75L10.25 3.75" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 8.75L15.75 3.75" stroke="currentColor" strokeWidth="1.5"/><path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClapboardSparkle;
